/**
 * Admin container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import AdminConsole from '../../Components/Admin/Admin';
import adminActions from './actions';
import {
  loadingSelector,
  errorSelector,
  userSelector,
  countSelector,
} from './selectors';
import appActions from '../App/actions';

/**
 * Admin properties to be provided to the admin console component

 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  users: userSelector(state),
  count: countSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch admin actions
 */
const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(appActions.logout()),
  fetchUsers: (search) => dispatch(adminActions.fetchUsers(search)),
});

/**
 * Connects admin state to the Admin Console component

 * @param {object} mapStateToProps admin data object to become props for the Admin component
 * @param {object} mapDispatchToProps admin actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminConsole),
);
